module.exports = __webpack_public_path__ + "img/btn_ip_minus.660c6d8e.svg";